import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    title: getDefaultValue(
      searchParams.get('title'),
      'Участвуйте в квизе с СК Ротор',
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    startFrom: parseInt(searchParams.get('startFrom') || '') || 3,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 100,

    sizeQR: searchParams.get('sizeQR') || '71.7',
    questionFontSize: searchParams.get('questionFontSize') || '5.2',
    answerFontSize: searchParams.get('answerFontSize') || '6.25',
    varNumFontSize: searchParams.get('varNumFontSize') || '6.25',
    iactiveIds: searchParams.get('iactiveIds'),
    mode: searchParams.get('mode') || 'allMessages' || 'onlyAllBroadcasts',

    // не испоьзуются
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    paddingQR: searchParams.get('paddingQR') || '0',
    carousel: searchParams.get('carousel') || '1',
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    phoneNumber,
    socials: searchParams.get('socials'),
    titleFontSize: searchParams.get('titleFontSize') || '8.6',
  };
};
